/* eslint-disable import/prefer-default-export */
import { defineStore } from "pinia";
import axios from "axios";
import { useDistributionStore } from "./useDistributionStore";
export const useUpdateDistributionStore = defineStore("updateDistributionStore", {
  state: () => ({
    newDistribution: {},
    unItemiziseDistributions: {},
    shareDistribution: {},
    originationDistribution: {},
    responsibleDistribution: {},
    referralDistribution: {},
    expensesDistribution: {},
    updatedDistribution: {},
    alerts: {}
  }),
  actions: {
    async createPaymentDistribution(body, type) {
      const distributionStore = useDistributionStore();
      try {
        const response = await axios({
          url: "/distributions",
          data: body,
          method: 'POST'
        });
        this.newDistribution = response.data;
        response.data.value = response.data.id;
        distributionStore.allDistributionsList.push(response.data);
        if (type === "unItemiziseDistributions") {
          this.unItemiziseDistributions = response.data.id;
        } else if (type === "shareDistribution") {
          this.shareDistributionId = response.data.id;
          this.shareDistribution.distributionId = response.data.id;
          this.shareDistribution.share = true;
        } else if (type === "originationDistribution") {
          this.originationDistributionId = response.data.id;
          this.originationDistribution.distributionId = response.data.id;
          this.originationDistribution.origination = true;
        } else if (type === "responsibleDistribution") {
          this.responsibleDistributionId = response.data.id;
          this.responsibleDistribution.distributionId = response.data.id;
          this.responsibleDistribution.responsible = true;
        } else if (type === "referralDistribution") {
          this.referralDistributionId = response.data.id;
          this.referralDistribution.distributionId = response.data.id;
          this.referralDistribution.referral = true;
        } else if (type === "expensesDistribution") {
          this.expensesDistributionId = response.data.id;
          this.expensesDistribution.distributionId = response.data.id;
          this.expensesDistribution.expenses = true;
        }
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    },
    async updatePaymentDistribution(body) {
      const distributionStore = useDistributionStore();
      try {
        const response = await axios({
          url: `/distributions/${body.id}`,
          data: body,
          method: 'PUT'
        });
        this.updatedDistribution = response.data;
        distributionStore.listPaymentDistributions();
      } catch (error) {
        this.alerts.error(error.response.data.message);
      }
    }
  }
});